var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTouch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11_2502",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.1875,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11_2502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8208 21.6875C10.3156 21.6875 9.83804 21.5811 9.38804 21.3683C8.93804 21.1554 8.56179 20.8497 8.25929 20.451L3.16504 13.8528L3.53429 13.4588C3.78429 13.1921 4.08329 13.0318 4.43129 12.978C4.77929 12.924 5.10521 12.99 5.40904 13.176L7.84579 14.4838V6.57227C7.84579 6.35977 7.91771 6.1816 8.06154 6.03777C8.20521 5.8941 8.38337 5.82227 8.59604 5.82227C8.80871 5.82227 8.98937 5.8941 9.13804 6.03777C9.28671 6.1816 9.36104 6.35977 9.36104 6.57227V17.1318L6.35904 15.497L9.47829 19.5625C9.64246 19.7688 9.84246 19.9246 10.0783 20.0298C10.3143 20.1349 10.5618 20.1875 10.8208 20.1875H15.7398C16.3668 20.1875 16.9002 19.9693 17.34 19.5328C17.7797 19.0961 17.9995 18.5643 17.9995 17.9375V14.1683C17.9995 13.8249 17.8835 13.5372 17.6513 13.305C17.419 13.0728 17.1312 12.9568 16.788 12.9568H11.7458V11.4568H16.788C17.5412 11.4568 18.1814 11.7203 18.7085 12.2475C19.2359 12.7748 19.4995 13.4151 19.4995 14.1683V17.9368C19.4995 18.9731 19.1314 19.8573 18.395 20.5895C17.6589 21.3215 16.7738 21.6875 15.7398 21.6875H10.8208ZM4.70354 8.82227C4.50604 8.4876 4.35537 8.12977 4.25154 7.74877C4.14771 7.36777 4.09579 6.9756 4.09579 6.57227C4.09579 5.32343 4.53362 4.26127 5.40929 3.38577C6.28479 2.5101 7.34696 2.07227 8.59579 2.07227C9.84446 2.07227 10.9066 2.5101 11.7823 3.38577C12.6578 4.26127 13.0955 5.32302 13.0955 6.57102C13.0955 6.97685 13.0436 7.36985 12.9398 7.75002C12.836 8.13018 12.6854 8.4876 12.488 8.82227L11.1958 8.07227C11.3291 7.83893 11.4291 7.60143 11.4958 7.35977C11.5625 7.1181 11.5958 6.8556 11.5958 6.57227C11.5958 5.73893 11.3041 5.0306 10.7208 4.44727C10.1375 3.86393 9.42912 3.57227 8.59579 3.57227C7.76246 3.57227 7.05412 3.86393 6.47079 4.44727C5.88746 5.0306 5.59579 5.73893 5.59579 6.57227C5.59579 6.8556 5.62912 7.1181 5.69579 7.35977C5.76246 7.60143 5.86246 7.83893 5.99579 8.07227L4.70354 8.82227Z",
    fill: "#797D8D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTouch);
export default __webpack_public_path__ + "static/media/Touch.f6fe2674a61c8b9c575e68a3eb705ffc.svg";
export { ForwardRef as ReactComponent };